module.exports = __webpack_public_path__ + "img/img4.80423c30.svg";